import React from 'react'
import { Button } from "@material-ui/core"
import { withStyles } from '@material-ui/core/styles'

const st = {
  borderRadius: '0px',
  fontWeight: 'bold',
}

function PrimaryButton({ classes, className, style, ...props }) {
  return (
    <Button
      style={{ ...style, ...st }}
      className={[classes.button, className].join(' ')}
      color='primary'
      variant='contained'
      {...props}
    />
  )
}

const styles = _ => ({

})

export default withStyles(styles)(PrimaryButton)